import getCombatantIndexById from "./getCombatantIndexById";
import store from "../store/index";
//-----------------------
// reduce counters count
//-----------------------
export default function reduceCountersCount(id) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //--------------------
  // get combatant index
  //--------------------
  console.log("ID2 = " + id)

  let idx = getCombatantIndexById(id);

  console.log("current counters idx = " + idx);
  console.log("current counters = " + combatants[idx].counters);
  //---------------------
  // reduce action count
  //---------------------
  combatants[idx].counters--;
}
